import { ColorSizeStock } from "../interfaces";

export const calculateStock = (size: ColorSizeStock) =>
  Math.max(
    0,
    size.stock.reduce((sum: number, st: any) => sum + st.qtyAvailable, 0),
  );

export const getLocationStock = (size: ColorSizeStock, regionID: string) => {
  const match = size.stock.find((s: any) => s.location === regionID);
  return match ? Math.max(0, match.qtyAvailable) : 0;
};

export const getOverseaStock = (stocks: ColorSizeStock[], sku: string) => {
  if (stocks.length === 0) return "-";
  const sizeData = stocks.find((s: ColorSizeStock) => s.sku === sku);
  if (!sizeData?.stock) return "N/A";
  return Math.max(
    0,
    sizeData.stock.reduce((sum: number, st: any) => sum + st.qtyAvailable, 0),
  );
};
